export const FLASH_WARNING = "Warning";
export const FLASH_SUCCESS = "Success";
export const FLASH_ERROR = "Error";
export const FLASH_PENDING = "Pending";
